import * as React from "react";
import { Box, Grid, Snackbar, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Footer from "../Footer";
import Toolbar from "@mui/material/Toolbar";
import Alert from "@mui/material/Alert";
import CircleIcon from "@mui/icons-material/Circle";
import { useHistory, useLocation } from "react-router-dom";
import { headerActions } from "../../store/header";
import bglService from "../../services/bgl";
import { bglOperations, classSuperOperations } from "../../services/constants";
import questionnaireReponseService from "../../services/questionnaireResponse";
import userService from "../../services/user";
import BGLHealthCheckModal from "../bglHealthCheckModal";
import { useEffect, useState } from "react";
import classSuperService from "../../services/superClass";
import ClassSuperHealthCheckModal from "../classSuperHealthCheckModal";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";

const useStyles = makeStyles((theme) => ({
  createAccountBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "16px",
    width: "800px",
    height: "auto",
  },
  createAccountLbl: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    color: "#000000",
    marginBlock: 0,
    marginBottom: 32,
  },
  textFieldLabel: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#000000",
    marginBlock: 0,
  },
  smallTextFieldLabel: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "9px",
    lineHeight: "16px",
    color: "#000000",
    letterSpacing: "0.1em",
  },
  red: {
    color: "red",
  },
  textField: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    background: "#ECEFF1",
    alignSelf: "stretch",
    height: "44px",
    paddingLeft: 8,
    paddingRight: 8,
  },
  text14: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
  },
  text12: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "24px",
  },
  phoneField: {
    padding: "0px 0px 0px 4px !important",
    height: "0px",
    display: "inline-block",
    fontSize: "14px",
  },
  crossIcon: {
    position: "absolute",
    right: "24px",
    cursor: "pointer",
  },
  heading: {
    fontFamily: "Poppins",
    fontWeight: "bold",
    fontSize: "32px",
    lineHeight: "48px",
  },
  legend: {
    fontFamily: "Poppins",
    fontSize: "12px",
    lineHeight: "24px",
    display: "flex",
    justifyContent: "space-between",
    width: "32%",
    marginLeft: "68%",
  },
}));

function useQueryParams() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function FundsList() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [fundsList, setFundsList] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [lastCheckedAt, setLastCheckedAt] = React.useState("");
  const [max, setMax] = React.useState(50);
  const [isBglUnreachable, setIsBglUnreachable] = React.useState(false);
  const [isClassSuperUnreachable, setIsClassSuperUnreachable] =
    React.useState(false);
  const [invalidTokenResponse, setInvalidTokenResponse] = React.useState(false);
  const isUserLoggedIn = useSelector((state) => state.auth.loggedIn);
  const user = useSelector((state) => state?.auth?.user);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");

  const selectedProduct = JSON.parse(localStorage.getItem("selectedProduct"));

  React.useEffect(() => {
    if (!(selectedProduct && selectedProduct.id)) {
      window.location.href = "/";
    }
  }, [selectedProduct]);

  const fetchFundList = async (max) => {
    setIsLoading(true);
    let totalRecordsFetched = 0;
    let offset = 0;
    let dataList = [];
    while (true) {
      let responseData = await bglService.getUserBglData(
        bglOperations.ENTITYLISTWITHMEMBERS,
        { offset, max }
      );
      responseData = JSON.parse(responseData.split("body=")[1].slice(0, -1));
      console.log("RESSSS", responseData);
      console.log("responseData.error", responseData.error);

      if (responseData.error) {
        if (user) {
          // update bgl token status
          await userService.updateUsersKey({
            type: "bglIsValid",
            data: { bglIsValid: false, userId: user.id },
          });
        }
        setInvalidTokenResponse(true);
        break;
      }
      totalRecordsFetched += max;

      offset = totalRecordsFetched;
      dataList = dataList.concat(responseData.fundsWithMembers);
      if (totalRecordsFetched >= responseData.total) {
        break;
      }
    }
    if (
      Object.keys(dataList) === "status" &&
      (dataList.status > 400 || dataList.status < 600)
    ) {
      setLastCheckedAt(moment().format("hh:mm"));
      setIsBglUnreachable(true);
      console.log("dataList", JSON.stringify(dataList));
      dispatch(headerActions.handleOpenBGLHealthCheckModal());
      setFundsList(null);
      setIsLoading(false);
      return;
    }
    let finalList = [];
    const questionnaireResponse =
      await questionnaireReponseService.getAllLatestCompleteQRByEmailByProduct(
        selectedProduct.id
      );
    if (questionnaireResponse !== undefined) {
      finalList = dataList?.map((e, i) => {
        let filteredRes = questionnaireResponse.filter(
          (element) => element.fundId === e.fundID
        );
        if (filteredRes.length > 0) {
          let data = filteredRes?.reduce((a, b) => {
            return new Date(a.updatedAt) > new Date(b.updatedAt) ? a : b;
          });
          e.reportDate = moment(data.updatedAt).format("DD/MM/YYYY");
        }
        return e;
      });
    } else {
      dataList?.map((element, index) => {
        return (dataList[index].reportDate = "");
      });
      finalList = dataList;
    }
    console.log("fina", finalList);
    setFundsList(finalList);

    if (query.get("extraReportPurchaseComplete") === "1") {
      const selectedFundID = localStorage.getItem("selectedFundID");
      const selectedFund = finalList.find(
        (fund) => fund.fundID === selectedFundID
      );
      dispatch(headerActions.handleSelectedFund(selectedFund));
      localStorage.removeItem("selectedFundID");
      if (selectedFundID) {
        history.push("/fundDetails");
      }
    }

    localStorage.removeItem("selectedFundID");
    setIsLoading(false);
  };
  // Function to fetch class Super List
  const fetchFundListClassSuper = async (max) => {
    setIsLoading(true);
    let totalRecordsFetched = 0;
    let offset = 0;
    let dataList = [];
    // while (true) {
    let responseData = await classSuperService.getClassSuperData(
      classSuperOperations.FUND_LIST,
      { offset, max }
    );

    responseData = JSON.parse(responseData.split("body=")[1].slice(0, -1));
    if (!responseData.Errors.length) {
      const obj = {
        fundsWithMembers: responseData.Data?.FundSummaries,
        total: responseData.Data?.TotalCount,
        offset: 0,
        max: 50,
      };

      if (responseData.error) {
        if (user) {
          await userService.updateUsersKey({
            type: "classSuperIsValid",
            data: { classSuperIsValid: false, userId: user.id },
          });
        }
        setInvalidTokenResponse(true);
        // break;
      }
      totalRecordsFetched += max;
      offset = totalRecordsFetched;
      dataList = dataList.concat(responseData.Data?.FundSummaries);

      if (totalRecordsFetched >= responseData.Data?.TotalCount) {
        // break;
      }
      // }

      if (
        Object.keys(dataList) === "status" &&
        (dataList.status > 400 || dataList.status < 600)
      ) {
        setLastCheckedAt(moment().format("hh:mm"));
        setIsClassSuperUnreachable(true);

        dispatch(headerActions.handleOpenClassSuperHealthCheckModal());
        setFundsList(null);
        setIsLoading(false);
        return;
      }
      let finalList = [];
      const questionnaireResponse =
        await questionnaireReponseService.getAllLatestCompleteQRByEmailByProduct(
          selectedProduct.id
        );

      if (questionnaireResponse !== undefined) {
        finalList = dataList?.map((e, i) => {
          let filteredRes = questionnaireResponse.filter(
            (element) => element.fundId === e.Code
          );

          if (filteredRes.length > 0) {
            let data = filteredRes?.reduce((a, b) => {
              return new Date(a.updatedAt) > new Date(b.updatedAt) ? a : b;
            });
            e.reportDate = moment(data.updatedAt).format("DD/MM/YYYY");
          }
          return e;
        });
      } else {
        dataList?.map((element, index) => {
          return (dataList[index].reportDate = "");
        });
        finalList = dataList;
      }

      const filterList = finalList.filter((e) => {
        return e.LegalEntityType === "SMSF";
      });

      setFundsList(filterList);

      if (query.get("extraReportPurchaseComplete") === "1") {
        const selectedFundID = localStorage.getItem("selectedFundID");
        const selectedFund = filterList.find(
          (fund) => fund.fundID === selectedFundID
        );
        dispatch(headerActions.handleSelectedFund(selectedFund));
        localStorage.removeItem("selectedFundID");
        if (selectedFundID) {
          history.push("/fundDetails");
        }
      }

      localStorage.removeItem("selectedFundID");
      setIsLoading(false);
    } else {
      console.log("ClassSuper Lambda Error");
    }
  };

  React.useEffect(() => {
    try {
      console.log("user", user);
      if (user && user.id) {
        if (user?.consentType === "class_super") {
          fetchFundListClassSuper(max);
        } else {
          fetchFundList(max);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [user]);

  const handleRowClick = async (rowData) => {
    console.log(rowData);
    dispatch(headerActions.handleSelectedFund(rowData));
    history.push("/fundDetails");
  };

  const query = useQueryParams();
  const [openToast, setOpenToast] = useState(false);
  const handleCloseToast = () => {
    setOpenToast(false);
    window.history.pushState({}, "", "/fundsList");
  };

  const [extraReportPurchaseMessage, setExtraReportPurchaseMessage] =
    useState(false);
  useEffect(() => {
    if (query.get("extraReportPurchaseComplete") === "1") {
      setExtraReportPurchaseMessage(true);
      setOpenToast(true);
    }
  }, [query, extraReportPurchaseMessage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  console.log("fundsListfundsListfundsList", fundsList);

  const filteredFundsList = fundsList.filter((row) => {
    if (user.bglIsValid) {
      return (
        row.code?.toLowerCase().includes(searchQuery) ||
        row.fundName?.toLowerCase().includes(searchQuery) ||
        // row.fundEmail.toLowerCase().includes(searchQuery) ||
        row.ABN?.toLowerCase().includes(searchQuery)
      );
    } else {
      return (
        row.Code?.toLowerCase().includes(searchQuery) ||
        row.Name?.toLowerCase().includes(searchQuery) ||
        // row.fundEmail.toLowerCase().includes(searchQuery) ||
        row.ABN?.toLowerCase().includes(searchQuery)
      );
    }
  });

  console.log("filteredFundsList", filteredFundsList);

  return (
    <>
      {extraReportPurchaseMessage && (
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseToast}
            severity="success"
            sx={{ width: "100%" }}
          >
            Successfully purchased extra reports
          </Alert>
        </Snackbar>
      )}
      {isUserLoggedIn && user && user.email && user.bglIsValid && (
        <Box
          bgcolor="#FAFAFA"
          sx={{ padding: "106px 32px", width: "100%", pb: 0 }}
        >
          <Grid style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography className={classes.heading}>SMSF Funds List</Typography>
            {isBglUnreachable && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <img
                    src="/broken-connection.jpg"
                    style={{ height: 45, width: 45 }}
                  />
                </div>
                <div
                  className={classes.text12}
                  style={{
                    textAlign: "center",
                    color: "#EC0018",
                    marginLeft: "4px",
                  }}
                >
                  {" "}
                  BGL unreachable <br />
                  (last checked at: {lastCheckedAt})
                </div>
              </div>
            )}
          </Grid>
          <Grid mt={2}>
            <Typography className={classes.legend}>
              <div>
                <strong>Legend:</strong>
              </div>
              <CircleIcon
                style={{
                  color: "#2AD000",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Done within 12 months
              <CircleIcon
                style={{
                  color: "#FF9900",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Done outside of 12 months
              <CircleIcon
                style={{
                  color: "#EC0018",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Outstanding
            </Typography>
          </Grid>
          <Grid mt={2}>
            <TextField
              label="Search"
              variant="outlined"
              fullWidth
              onChange={handleSearchChange}
              sx={{
                marginBottom: "20px",
                backgroundColor: "#FFFFFF",
                width: "30%",
              }}
            />
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#FFFFFF" }}>
                    {[
                      "Fund Code",
                      "Fund Name",
                      "Email Address",
                      "ABN",
                      "Report Date",
                      "Status",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          fontWeight: "700",
                          borderTop: "1px solid #C1C1C1",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredFundsList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.fundCode}
                        sx={{
                          backgroundColor: index % 2 ? "#F2F3F3" : "#FFFFFF",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        <TableCell>{row.fundCode}</TableCell>
                        <TableCell>{row.fundName}</TableCell>
                        <TableCell
                          sx={{ whiteSpace: "nowrap", overflow: "hidden" }}
                        >
                          {row.fundEmail}
                        </TableCell>
                        <TableCell>{row.ABN}</TableCell>
                        <TableCell>
                          {row.reportDate
                            ? moment(row.reportDate, "DD/MM/YYYY").format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {!row.reportDate ? (
                            <CircleIcon style={{ color: "#EC0018" }} />
                          ) : Math.abs(
                              moment().diff(
                                moment(row.reportDate, "DD/MM/YYYY"),
                                "days"
                              )
                            ) < 365 ? (
                            <CircleIcon style={{ color: "#2AD000" }} />
                          ) : (
                            <CircleIcon style={{ color: "#FF9900" }} />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20, 25, 50]}
              component="div"
              count={filteredFundsList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>

          {invalidTokenResponse && (
            <Alert severity="error">
              Invalid BGL token.{" "}
              <a href="/profile/bglConsentStatus"> Click here to reconnect </a>.
            </Alert>
          )}
          <Toolbar />
          <Footer />
        </Box>
      )}
      {/* Table for class Super Data */}
      {isUserLoggedIn && user && user.email && user.classSuperIsValid && (
        <Box
          bgcolor="#FAFAFA"
          sx={{ padding: "106px 32px", width: "100%", pb: 0 }}
        >
          <Grid style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography className={classes.heading}>SMSF Funds List</Typography>
            {isClassSuperUnreachable && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <img
                    src="/broken-connection.jpg"
                    style={{ height: 45, width: 45 }}
                  />
                </div>
                <div
                  className={classes.text12}
                  style={{
                    textAlign: "center",
                    color: "#EC0018",
                    marginLeft: "4px",
                  }}
                >
                  {" "}
                  Class Super unreachable <br />
                  (last checked at: {lastCheckedAt})
                </div>
              </div>
            )}
          </Grid>
          <Grid mt={2}>
            <Typography className={classes.legend}>
              <div>
                <strong>Legend:</strong>
              </div>
              <CircleIcon
                style={{
                  color: "#2AD000",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Done within 12 months
              <CircleIcon
                style={{
                  color: "#FF9900",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Done outside of 12 months
              <CircleIcon
                style={{
                  color: "#EC0018",
                  fontSize: "medium",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              />{" "}
              Outstanding
            </Typography>
          </Grid>
          <Grid mt={3}>
            <TextField
              label="Search"
              variant="outlined"
              fullWidth
              onChange={handleSearchChange}
              sx={{
                marginBottom: "20px",
                backgroundColor: "#FFFFFF",
                width: "30%",
              }}
            />
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#FFFFFF" }}>
                    {[
                      "Fund Code",
                      "Fund Name",
                      "Email Address",
                      "ABN",
                      "Report Date",
                      "Status",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          fontWeight: "700",
                          borderTop: "1px solid #C1C1C1",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredFundsList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.Code}
                        sx={{
                          backgroundColor: index % 2 ? "#F2F3F3" : "#FFFFFF",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        <TableCell>{row.Code}</TableCell>
                        <TableCell>{row.Name}</TableCell>
                        <TableCell
                          sx={{ whiteSpace: "nowrap", overflow: "hidden" }}
                        >
                          {row.fundEmail}
                        </TableCell>
                        <TableCell>{row.ABN}</TableCell>
                        <TableCell>
                          {row.reportDate
                            ? moment(row.reportDate, "DD/MM/YYYY").format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {!row.reportDate ? (
                            <CircleIcon style={{ color: "#EC0018" }} />
                          ) : Math.abs(
                              moment().diff(
                                moment(row.reportDate, "DD/MM/YYYY"),
                                "days"
                              )
                            ) < 365 ? (
                            <CircleIcon style={{ color: "#2AD000" }} />
                          ) : (
                            <CircleIcon style={{ color: "#FF9900" }} />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20, 25, 50]}
              component="div"
              count={filteredFundsList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>

          {invalidTokenResponse && (
            <Alert severity="error">
              Invalid Class Super token.{" "}
              <a href="/profile/classSuperConsentStatus">
                {" "}
                Click here to reconnect{" "}
              </a>
              .
            </Alert>
          )}
          <Toolbar />
          <Footer />
        </Box>
      )}
      <BGLHealthCheckModal />
      <ClassSuperHealthCheckModal />
    </>
  );
}
